<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic"
                      type="gradient-red"
                      sub-title="350,897"
                      icon="ni ni-active-40"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic"
                      type="gradient-orange"
                      sub-title="2,356"
                      icon="ni ni-chart-pie-35"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Sales"
                      type="gradient-green"
                      sub-title="924"
                      icon="ni ni-money-coins"
                      class="mb-4">

            <template slot="footer">
              <span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Performance"
                      type="gradient-info"
                      sub-title="49,65%"
                      icon="ni ni-chart-bar-32"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
              <b-card-header class="border-0">
                  <h3 class="mb-0">Módulos del Pos</h3>
              </b-card-header>
              <div class="card-body table-responsive p-0">
                <table id="ListModulos" class="table table-hover">
                    <tbody>
                    <tr>
                        <th>Id</th>
                        <th>Descripción</th>
                        <th>Creado el</th>                                                
                        <th>Actualizado el</th>
                        <th>Acciones</th>
                    </tr>

                    <tr v-for="modulo in modulos" :key="modulo.id">
                        <td>{{modulo.id}}</td>
                        <td>{{modulo.descripcion}}</td>                        
                        <td>{{modulo.createdAt | myDate}}</td>
                        <td>{{modulo.updatedAt | myDate}}</td>
                        <td>
                            <base-button size="sm"
                                v-b-popover.hover.top="'Editar Módulo'"
                                type="secondary"
                                @click="editModal(modulo)"
                            >
                            <i class="fa fa-edit"></i>
                            </base-button>                    
                            <!--[ngClass]="{'disabled':modulo.Estatus == -1 || modulo.Estatus == 0}"-->
                            <base-button size="sm"                            
                                v-b-popover.hover.top="'Eliminar Módulo'"
                                type="danger"
                                @click="deleteAccion(modulo.Id)"
                            >
                            <i class="fa fa-trash"></i>
                            </base-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <!-- /.card -->
              </div>
              <b-card-footer class="py-4 d-flex justify-content-end">
                  <base-pagination @change="getResults" aria-controls="ListModulos" v-model="currentPage" :per-page="perPage" :total="30"></base-pagination>
              </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>


    <!-- Modal -->
    <b-modal ref="modal-1" size="md" hide-backdrop centered hide-footer>
        <template #modal-title>
            <h5 class="modal-title" v-show="!editmode" id="addNewLabel">Guardar Acción</h5>
            <h5 class="modal-title" v-show="editmode" id="addNewLabel">Actualizar Acción</h5>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <div class="modal-body">
              <div class="container">
                <h6 class="heading-small text-muted mb-4">Módulos</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        required       
                        type="text"
                        label="Descripción"
                        placeholder="Ej. accionA"                        
                        v-model="form.descripcion"
                      >
                      </base-input>
                    </b-col>
                  </b-row>               
                </div>
              </div>
            </div>
           
            <div class="modal-footer">
              <b-button size="sm" type="button" class="btn btn-danger" @click="hideModal" >Cerrar</b-button>
              <b-button size="sm" v-show="editmode" type="submit" class="btn btn-success">Actualizar</b-button>
              <b-button size="sm" v-show="!editmode" type="submit" class="btn btn-primary">Guardar</b-button>
            </div>
          </form>
    </b-modal>
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    components: {
      //LightTable,
      //DarkTable,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      perPage:10,
      currentPage: 1,
      modulos:[],      
      form: new Form({
        id: 0,
        descripcion: '',
        rolId: '',
        moduloId:'',
        estatus: true
      }),
      };
    },
    methods: {
      getResults(page = 1) {      
        axios.get(this.$gate.getApiUrl()+'Modulo?page='+page+'&perPage='+this.perPage)
        .then(({ data }) => {
          this.modulos = data;          
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }
        });
      },
      editModal(modulo){
        this.editmode = true;
        this.form.reset();        
        this.$refs['modal-1'].show();       
        this.form.fill(modulo);    
      },
      updateCaja(){        
        //this.$gate.getApiUrl()+
        this.form.put(this.$gate.getApiUrl()+'Modulo/'+this.form.id)
          .then(() => {
            // success
            Fire.$emit('AfterCreate');
            this.$refs['modal-1'].hide();

            this.$swal({
              title: 'Módulo Actualizado',
              icon: 'success',
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              timer: 3000
            })            
          //this.$Progress.finish();
        })
        .catch((e) => {
          //console.log(e)

          //this.$Progress.fail();
        });
        this.hideModal();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      loadAcciones(){
        //if(this.$gate.isAdminOrAuthor()){
           this.getResults();
          //await axios.get(this.$gate.getApiUrl()+"Accion").then(({ data }) => {this.modulos = data; });
          //await axios.get(this.$gate.getApiUrl()+"Rol").then(({ data }) => {this.roles = data; this.getSelectRoles(); });
          //await axios.get(this.$gate.getApiUrl()+"Modulo").then(({ data }) => {this.modulos = data; this.getSelectModulos(); });
        //}
      },

    },
    created(){
      this.loadAcciones();
      Fire.$on('AfterCreate',() => {
        this.getResults();
      });      
    },
    computed:{
      rows() {
        return this.modulos.length
      },
    }
  };
</script>
<style>

</style>